export default __webpack_public_path__ + "static/media/i027vp.c568944a.webp";